// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var Api = {
  name: "V3Tutorial"
};

var Context = ContextMaker$LiteracyplanetClientFlags.Make(Api);

function V3TutorialContext$Provider(props) {
  var defaultState = props.defaultState;
  var match = React.useState(function () {
        return defaultState;
      });
  var setState = match[1];
  return React.createElement(Context.Provider.make, {
              value: {
                state: match[0],
                onFinishedReading: (function () {
                    setState(function (param) {
                          return "FinishedReadingTutorial";
                        });
                  }),
                onSetReadingTutorial: (function () {
                    setState(function (param) {
                          return "ReadingTutorial";
                        });
                  })
              },
              children: props.children
            });
}

var Provider = {
  make: V3TutorialContext$Provider
};

var use = Context.use;

export {
  Api ,
  Context ,
  use ,
  Provider ,
}
/* Context Not a pure module */
